import request from '../../utils/request'

const preFix = '/system/users';

export const reqListUsers = (data) => {
    return request({
        url: preFix + '/list',
        method: 'POST',
        data: data
    })
}
export const reqInsertUsers = (data) => {
    return request({
        url: preFix + '/insert',
        method: 'POST',
        data: data
    })
}
export const reqUpdateUsers = (data) => {
    return request({
        url: preFix + '/update',
        method: 'POST',
        data: data
    })
}
export const reqDeleteUsersById = (data) => {
    return request({
        url: preFix + '/delete',
        method: 'get',
        params: data
    })
}
export const reqGetUsersById = (data) => {
    return request({
        url: preFix + '/detail',
        method: 'get',
        params: data
    })
}

export const reqAuthRoleByUserId = (data) => {
    return request({
        url: preFix + '/authRole',
        method: 'post',
        data: data
    })
}
export const reqAuthEmployeeShop = (data) => {
    return request({
        url: '/system/employee/shop/auth',
        method: 'post',
        data: data
    })
}
export const reqListDelivery = (data) => {
    return request({
        url: '/system/delivery/list',
        method: 'post',
        data: data
    })
}
export const reqListAllUsersByPhone = (data) => {
    return request({
        url: '/system/users/listAllByPhone',
        method: 'get',
        params: data
    })
}
